import React, {useEffect, useRef, useState} from 'react'
import {withAppContextDecorators} from '@/common/AppContext';
import ProTable from '@ant-design/pro-table';

import {Breadcrumb, Table, Button} from 'antd';
import api from "@/services/api";
import commonSetting from "@/config/commonSetting";
import './index.less'
import LayoutContainer from "@/components/pc/LayoutContainer";
import {useHistory} from 'react-router-dom';


const AboutUs = (props) => {
    const history = useHistory()
    const introduce = {
        title: '深圳市国诚投资咨询有限公司',
        subTitle: 'Shenzhen Quadrel Investment Consulting Ltd',
        introduction: ['国诚投顾是一家完全依靠市场竞争成长起来的专业投资咨询机构，致力于通过专业的研究与服务协助客户实现资产的保值与增值。',
            '深圳市国诚投资咨询有限公司成立于2004年，总部位于中国深圳。公司一直秉承规范、诚信、创新的宗旨，立足专业投研辅助选股决策，构建盈利体系，提高投资能力。',
            '公司致力打造集合投研资讯加工、投资者教育、选股决策辅助的综合互联网产品，立足专业的深度调研，帮助客户构建自己的盈利体系，提高自身投资能力。']
    }
    //控制国诚理念部分切换结构的变量
    const [activePosterIndex, setActivePosterIndex] = useState(2)
    //控制发展历程部分切换结构的变量
    const [activeHistoryIndex, setActiveHistoryIndex] = useState(2)

    // 控制发展历程左右两个箭头的显示与隐藏
    const [leftHistoryShowing, setLeftHistoryShowing] = useState(true)
    const [rightHistoryShowing, setRightHistoryShowing] = useState(true)


    //存储老师信息
    const [teacherList, setTeacherList] = useState([])
    //存储当前需要展示在轮播图的部分老师信息
    const [currentTeacherList, setCurrentTeacherList] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    //当前展示的老师信息
    const [currentTeacher, setCurrentTeacher] = useState({})
    const [currentProgressIndex, setCurrentProgressIndex] = useState(0)

    //控制研究团队左右两个箭头的显示与隐藏
    const [leftResearchShowing, setLeftResearchShowing] = useState(currentPage === 1)
    const [rightResearchShowing, setRightResearchShowing] = useState(true)
    const [practitionerList, setPractitionerList] = useState([])

    const timerId = useRef(null)

    const getTeacherList = async () => {
        const resp = await api.pubController.publicAnalystGwListUsingGET()
        // console.log(resp)
        setTeacherList(resp.data)
        let pageCount = Math.ceil(resp.data.length / 7)
        // console.log('pageCount', pageCount)
        // console.log('currentPage', currentPage)
        setRightResearchShowing(currentPage === pageCount)
        setCurrentTeacherList(resp.data.slice((currentPage - 1) * 7, (currentPage - 1) * 7 + 7))
        setCurrentTeacher(resp.data[0])
    }

    // const getPractitionerList = async () => {
    //     const resp = await api.pubController.publicGwStaffUsingGET({
    //         size: 10,
    //         current: 1
    //     })
    //     if(resp?.code === 0 && resp?.data) {
    //         const newData = resp?.data.map((item, index) => {
    //            return  {...item, index: index+1}
    //         })
    //         setPractitionerList(newData)
    //     }
    // }

    const columns = [
        {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            align: 'center'
        },
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
            align: 'center',
            render: (_, record) => record.name || '--'
        },
        {
            title: '执业编号',
            dataIndex: 'certificateNo',
            key: 'certificateNo',
            align: 'center',
            render: (_, record) => record.certificateNo || '--'
        },
        {
            title: '执业岗位',
            dataIndex: 'certificate',
            key: 'certificate',
            align: 'center',
            render: (_, record) => record.certificate || '--'
        },

    ];

    const handleMouseEnter = (index) => {
        setActivePosterIndex(index)
    }
    const handleMouseLeave = () => {
        setActivePosterIndex(2)
    }

    useEffect(async () => {
        await getTeacherList()
        // await getPractitionerList()
    }, [])


    return <LayoutContainer>
        <div id="aboutus">
            <div className={'banner'}>
                <img src={require('@/assets/images/aboutUs/banner.jpg')}/>
            </div>
            <div className={'breadcrumb-con warp'}>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item onClick={() => {
                        history.push({pathname: '/index'})
                    }}>首页</Breadcrumb.Item>
                    <Breadcrumb.Item onClick={() => {
                        history.push({pathname: '/aboutUs'})
                    }}>公司简介</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            {/*国诚简介部分结构*/}
            <div className={'company-intro warp'}>
                <div className={'module-title'}>
                    <h2>国诚简介</h2>
                    <p>Introduction</p>
                </div>

                <div className={'introduce-wrapper'}>
                    <div className={'introduce-desc'}>
                        <h3 className={'title'}>{introduce.title}</h3>
                        <h4 className={'subTitle'}>{introduce.subTitle}</h4>
                        <p className={'introduce'}>{introduce.introduction[0]}</p>
                        <p>{introduce.introduction[1]}</p>
                        <p>{introduce.introduction[2]}</p>
                    </div>
                    <img src={require("@/assets/images/aboutUs/introduction.png")}/>
                </div>

                <div className={'intro-board'}>
                    <div>
                        <span className={'top'}>2004</span>
                        <span className={'bottom'}>公司成立时间</span>
                    </div>
                    <div>
                        <span className={'top'}>10万+</span>
                        <span className={'bottom'}>注册用户</span>
                    </div>
                    <div>
                        <span className={'top'}>700+</span>
                        <span className={'bottom'}>工作人员</span>
                    </div>
                    <div>
                        <span className={'top'}>6000㎡</span>
                        <span className={'bottom'}>5A级办公环境</span>
                    </div>
                </div>
            </div>

            {/*国诚理念部分结构*/}
            <div className={'company-concept warp'}>
                <div className={'module-title'}>
                    <h2>国诚理念</h2>
                    <p>Quadrel Concept</p>
                </div>
                <div className="wrapper" onMouseLeave={() => {
                    handleMouseLeave()
                }}>
                    {
                        activePosterIndex === 1 ? <div className={'large-card'}>
                                <img src={require("@/assets/images/aboutUs/img1.png")} className={'poster'}/>
                                <div className={'poster-desc'}>
                                    <h2>01</h2>
                                    <p className={'zh-title'}>国诚愿景</p>
                                    <p className={'en-title'}>Quadrel Vision</p>
                                    <div className={'line'}/>
                                    <p className={'desc'}>用户为本，科技为先，以用户价值为依托，打造集合精品投研资讯，投资者教育，选股决策辅助的综合互联网产品服务。</p>
                                </div>
                            </div> :
                            <div className="card" onMouseEnter={() => {
                                handleMouseEnter(1)
                            }}>
                                <h2>01</h2>
                                <p className="subtitle">国诚愿景</p>
                                <p className={'en-title'}>Quadrel Vision</p>
                            </div>
                    }

                    {
                        activePosterIndex === 2 ?
                            <div className={'large-card'} style={{margin: "0 15px"}}>
                                <img src={require("@/assets/images/aboutUs/img2.png")} className={'poster'}/>
                                <div className={'poster-desc'}>
                                    <h2>02</h2>
                                    <p className={'zh-title'}>企业构成</p>
                                    <p className={'en-title'}>Enterprise Structure</p>
                                    <div className={'line'}/>
                                    <p className={'desc'}>公司具备完整的投资咨询体系，拥有强大的证券投资顾问咨询团队。目前职能部门为：策研中心、合规中心、大数据/云计算技术开发中心、客服售后中心、综管中心等。</p>
                                </div>
                            </div> :
                            <div className="card" onMouseEnter={() => {
                                handleMouseEnter(2)
                            }}>
                                <h2>02</h2>
                                <p className="subtitle">企业构成</p>
                                <p className={'en-title'}>Enterprise Structure</p>
                            </div>
                    }

                    {
                        activePosterIndex === 3 ? <div className={'large-card'}>
                                <img src={require("@/assets/images/aboutUs/img3.png")} className={'poster'}/>
                                <div className={'poster-desc'}>
                                    <h2>03</h2>
                                    <p className={'zh-title'}>企业文化</p>
                                    <p className={'en-title'}>Corporate Culture</p>
                                    <div className={'line'}/>
                                    <p className={'desc'} style={{width: '281px'}}>对客户：真诚、守正、敬业、专业、付出</p>
                                    <p className={'desc'} style={{width: '281px'}}>对工作：求实、进取、创新、协同、分享</p>
                                </div>
                            </div> :
                            <div className="card" onMouseEnter={() => {
                                handleMouseEnter(3)
                            }}>
                                <h2>03</h2>
                                <p className="subtitle">企业文化</p>
                                <p className={'en-title'}>Corporate Culture</p>
                            </div>
                    }
                </div>
            </div>

            {/*发展历程部分结构*/}
            <div className={'company-history warp'}>
                <div className={'module-title'}>
                    <h2 style={{marginTop:'30px'}}>发展历程</h2>
                    <p>Our History</p>
                </div>
                <div className='solid'/>
                <div className={'wrapper'}>
                    <img src={require("@/assets/images/aboutUs/prev_blue.png")} hidden={!leftHistoryShowing}
                         className={'controller prev'}
                         onClick={() => {
                             setActiveHistoryIndex(activeHistoryIndex < 2 ? 1 : activeHistoryIndex - 1)
                             setLeftHistoryShowing(activeHistoryIndex !== 2)
                             setRightHistoryShowing(true)
                         }
                         }/>

                    <img src={require("@/assets/images/aboutUs/prev_gray.png")} hidden={leftHistoryShowing}
                         className={'controller prev'}
                    />
                    <div className={'historyBox'}>
                        {
                            activeHistoryIndex === 1 ? <div className='active'>
                                <div className='img'><img src={require("@/assets/images/aboutUs/now.png")}/></div>
                                <div className='date'>2004</div>
                                <p>公司成立</p>
                            </div> : <div className='circleBox'>
                                <div className='circle' onClick={() => {
                                    setActiveHistoryIndex(1)
                                    setLeftHistoryShowing(false)
                                    setRightHistoryShowing(true)
                                }}/>
                            </div>
                        }

                        {
                            activeHistoryIndex === 2 ? <div className='active'>
                                <div className='img'><img src={require("@/assets/images/aboutUs/now.png")}/></div>
                                <div className='date'>2005</div>
                                <p>获得《经营证券期货业务许可证》</p>
                            </div> : <div className='circleBox'>
                                <div className='circle' onClick={() => {
                                    setActiveHistoryIndex(2)
                                    setLeftHistoryShowing(true)
                                    setRightHistoryShowing(true)
                                }}/>
                            </div>
                        }


                        {
                            activeHistoryIndex === 3 ? <div className='active'>
                                <div className='img'><img src={require("@/assets/images/aboutUs/now.png")}/></div>
                                <div className='date'>2012</div>
                                <p>成为中央电视台证券咨询频道合作伙伴，并共同打造《时间定势》栏目</p>
                            </div> : <div className='circleBox'>
                                <div className='circle' onClick={() => {
                                    setActiveHistoryIndex(3)
                                    setLeftHistoryShowing(true)
                                    setRightHistoryShowing(true)
                                }}/>
                            </div>
                        }
                        {
                            activeHistoryIndex === 4 ? <div className='active'>
                                <div className='img'><img src={require("@/assets/images/aboutUs/now.png")}/></div>
                                <div className='date'>2013</div>
                                <p>与湖北卫视合作打造《天生我财》栏目</p>
                            </div> : <div className='circleBox'>
                                <div className='circle' onClick={() => {
                                    setActiveHistoryIndex(4)
                                    setLeftHistoryShowing(true)
                                    setRightHistoryShowing(true)
                                }}/>
                            </div>
                        }
                        {
                            activeHistoryIndex === 5 ? <div className='active'>
                                <div className='img'><img src={require("@/assets/images/aboutUs/now.png")}/></div>
                                <div className='date'>2016</div>
                                <p>成立上海分公司</p>
                            </div> : <div className='circleBox'>
                                <div className='circle' onClick={() => {
                                    setActiveHistoryIndex(5)
                                    setLeftHistoryShowing(true)
                                    setRightHistoryShowing(true)
                                }}/>
                            </div>
                        }
                        {
                            activeHistoryIndex === 6 ? <div className='active'>
                                <div className='img'><img src={require("@/assets/images/aboutUs/now.png")}/></div>
                                <div className='date'>2021</div>
                                <p>客户订阅量达到30万</p>
                            </div> : <div className='circleBox'>
                                <div className='circle' onClick={() => {
                                    setActiveHistoryIndex(6)
                                    setLeftHistoryShowing(true)
                                    setRightHistoryShowing(true)
                                }}/>
                            </div>
                        }
                        {
                            activeHistoryIndex === 7 ? <div className='active'>
                                <div className='img'><img src={require("@/assets/images/aboutUs/now.png")}/></div>
                                <div className='date'>2022</div>
                                <p>注册用户量约达到10万，迁址到陆家嘴商圈，开启规模式大发展 </p>
                            </div> : <div className='circleBox'>
                                <div className='circle' onClick={() => {
                                    setActiveHistoryIndex(7)
                                    setLeftHistoryShowing(true)
                                    setRightHistoryShowing(false)
                                }}/>
                            </div>
                        }
                    </div>
                    <img src={require("@/assets/images/aboutUs/next_blue.png")} hidden={!rightHistoryShowing}
                         className={'controller next'}
                         onClick={() => {
                             setActiveHistoryIndex(activeHistoryIndex > 6 ? 7 : activeHistoryIndex + 1)
                             setRightHistoryShowing(activeHistoryIndex !== 6)
                             setLeftHistoryShowing(true)
                         }}/>
                    <img src={require("@/assets/images/aboutUs/next_gray.png")} hidden={rightHistoryShowing}
                         className={'controller next'}
                    />
                </div>
            </div>

            {/*研究团队部分结构*/}
            <div className={'bg'}>
                <div className={'research-team warp'}>
                    <div className={'module-title'}>
                        <h2 style={{paddingTop:'30px'}}>研究团队</h2>
                        <p>Consultant Details</p>
                    </div>
                    <div className={'wrapper clearfix'}>
                        <img src={commonSetting.OSS_URL + currentTeacher?.gwAvatarUrl}
                             className={'photo'}/>
                        <div className={'detail'}>
                            <p className={'title'}>{currentTeacher?.title}</p>
                            <div className={'info'}>
                                <div className={'name'}>{currentTeacher?.name}</div>
                                <p className={'id'}>执业编号：{currentTeacher?.certificateNo}</p>
                            </div>
                            <div className={'line'}/>
                            <div className={'sub-detail'} dangerouslySetInnerHTML={{__html: currentTeacher?.introduce}}/>

                        </div>
                    </div>
                    <div className={'carousel-wrapper'}>
                        <img src={require("@/assets/images/aboutUs/prev_blue.png")} hidden={leftResearchShowing}
                             className={'controller prev'}
                             onClick={() => {
                                 let prevPage = currentPage > 1 ? currentPage - 1 : currentPage
                                 setCurrentPage(prevPage)
                                 // console.log(currentPage)
                                 setCurrentTeacherList(teacherList.slice((prevPage - 1) * 7, (prevPage - 1) * 7 + 7))
                                 setCurrentTeacher(prevPage === currentPage ? currentTeacher : teacherList.slice((prevPage - 1) * 7, (prevPage - 1) * 7 + 7)[0])
                                 setCurrentProgressIndex(prevPage === currentPage ? currentProgressIndex : 0)
                                 setLeftResearchShowing(prevPage === 1)
                                 setRightResearchShowing(false)
                             }}/>
                        <img src={require("@/assets/images/aboutUs/prev_gray.png")} hidden={!leftResearchShowing}
                             className={'controller prev'}/>
                        <div className={'carousel'}>
                            {
                                currentTeacherList.length > 0 && currentTeacherList.map((item, index) =>
                                    <img src={commonSetting.OSS_URL + item.gwAvatarUrl} key={item.id} className={'photo'}
                                         onMouseEnter={() => {
                                             // console.log('切换')
                                             setCurrentTeacher(item)
                                             setCurrentProgressIndex(index)
                                         }}/>
                                )
                            }
                        </div>
                        <img src={require("@/assets/images/aboutUs/next_blue.png")} hidden={rightResearchShowing}
                             className={'controller next'} onClick={
                            () => {
                                let nextPage = currentPage === Math.ceil(teacherList.length / 7) ? currentPage : currentPage + 1
                                setCurrentPage(nextPage)
                                // console.log(currentPage)
                                setCurrentTeacherList(teacherList.slice((nextPage - 1) * 7, (nextPage - 1) * 7 + 7))
                                setCurrentTeacher(nextPage === currentPage ? currentTeacher : teacherList.slice((nextPage - 1) * 7, (nextPage - 1) * 7 + 7)[0])
                                setCurrentProgressIndex(nextPage === currentPage ? currentProgressIndex : 0)
                                setRightResearchShowing(nextPage === Math.ceil(teacherList.length / 7))
                                setLeftResearchShowing(false)
                            }
                        }/>
                        <img src={require("@/assets/images/aboutUs/next_gray.png")} hidden={!rightResearchShowing}
                             className={'controller next'}/>
                    </div>

                    {/*底部进度条*/}
                    <div className={'progressBar-wrapper'}>
                        {
                            currentTeacherList.length > 0 && currentTeacherList.map((item, index) =>
                                <div className={currentProgressIndex === index ? 'active' : 'progressBar'} key={index}/>
                            )
                        }
                    </div>
                </div>
            </div>
            {/*从业人员公示*/}
            <div className={'practitioner-team warp'}>
                <div className={'module-title'} style={{'marginBottom': '28px'}}>
                    <h2>从业人员公示</h2>
                    <p>Securities Practitioners</p>
                </div>
                {/*<Table columns={columns} dataSource={practitionerList} />*/}
                <ProTable
                    search={false}
                    split={true}
                    request={async (params, sorter = {}) => {

                        let resp = await api.pubController.publicGwStaffUsingGET({
                            size: 10,
                            current: 1
                        })
                        let newData = []
                        if(resp?.code === 0 && resp?.data) {
                            newData = resp?.data.map((item, index) => {
                                return  {...item, index: index+1}
                            })
                            setPractitionerList(newData)
                        }
                        return {
                            data: newData,
                            success: true,
                            total: resp?.pagination?.total,
                        }
                    }}
                    showActions="always"
                    columns={columns}
                    options={false}
                    pagination={false}
                />

                {/*更多详情*/}
                {practitionerList.length === 10 && <div className={'moreButton'} onClick={() => {
                    history.push({pathname: '/showPractitioner'})
                }}>更多详情</div>}
            </div>

        </div>
    </LayoutContainer>
}
export default withAppContextDecorators(AboutUs)
